import { useEffect, useRef } from "react";

const SearchBar = ({ placeholder = "Search...", searchQuery, setSearchQuery, onSearch }) => {
  const debounceTimer = useRef(null);

  const handleInputChange = (e) => {
    const value = e.target.value;
    setSearchQuery(value);

    // Clear previous debounce timer
    if (debounceTimer.current) {
      clearTimeout(debounceTimer.current);
    }

    // Trigger search after 800ms pause in typing
    debounceTimer.current = setTimeout(() => {
      onSearch(value);
    }, 800);
  };

  // Cleanup timer on unmount
  useEffect(() => {
    return () => {
      if (debounceTimer.current) {
        clearTimeout(debounceTimer.current);
      }
    };
  }, []);

  const handleSearchClick = () => {
    // Immediate search on button click — cancel any pending debounce
    if (debounceTimer.current) {
      clearTimeout(debounceTimer.current);
    }
    onSearch(searchQuery);
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      // Immediate search on Enter key
      if (debounceTimer.current) {
        clearTimeout(debounceTimer.current);
      }
      onSearch(searchQuery);
    }
  };

  return (
    <div className="search-bar" style={{ display: "flex", gap: "10px" }}>
      <input
        type="text"
        placeholder={placeholder}
        value={searchQuery}
        onChange={handleInputChange}
        onKeyDown={handleKeyDown}
        className="form-control"
      />
      <button className="btn btn-primary" onClick={handleSearchClick}>
        Search
      </button>
    </div>
  );
};

export default SearchBar;

